import { Pipe, PipeTransform } from '@angular/core';

/**
 * Returns only first letter of string
 */
@Pipe({
  name: 'promoType'
})
export class PromoTypePipe implements PipeTransform {
  transform(code: any, promo_type: any, promo_sub_type: any): any {
    switch(code) {
      case 'PP_CHALLENGE_PHASE_1':
        if (+promo_type == 4 && +promo_sub_type == 3) {
          return true;
        }
        break;
      case 'PP_CHALLENGE_PHASE_2':
        if (+promo_type == 3 && +promo_sub_type == 5) {
          return true;
        }
        break;
      case 'BTG_CHALLENGE_PHASE_1':
        if (+promo_type == 3 && +promo_sub_type == 6) {
          return true;
        }
        break;
      case 'BTG_CHALLENGE_PHASE_2':
        if (+promo_type == 3 && +promo_sub_type == 7) {
          return true;
        }
        break;
      case 'NORMAL_FREE_CREDIT':
        if (+promo_type == 3 && +promo_sub_type != 5) {
          return true;
        }
        break;
      case 'NORMAL_FREE_SPIN':
        if (+promo_type == 4 && +promo_sub_type != 3) {
          return true;
        }
        break;
      case 'NORMAL_WIHOUT_FREE_CREDIT':
        if (
          +promo_type == 1 || 
          +promo_type == 2 || 
          (+promo_type == 4 && +promo_sub_type != 3)
        ) {
          return true;
        }
        break;
      case 'NORMAL':
        if (
          +promo_type === 1 || 
          +promo_type === 2 || 
          (+promo_type === 4 && +promo_sub_type !== 3) || 
          (+promo_type === 3 && +promo_sub_type !== 5)
        ) {
          return true;
        }
        break;
    }

    return false;
  }
}